<p-dialog
  [visible]="visible()"
  (visibleChange)="visible.set($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [appendTo]="'body'"
  [style]="{ width: 'min(960px, 94vw)' }"
  [contentStyle]="{ overflow: 'auto', maxHeight: '70vh' }"
  [header]="headerKey() | translate"
  [closable]="!saving()"
  [closeOnEscape]="!saving()"
>
  @if (formError()) {
    <div class="error-message">{{ formError() | translate }}</div>
  }
  <div class="subscription-form">
    <msf-input
      [model]="name()"
      (modelChange)="setName($event)"
      [label]="'Name'"
    ></msf-input>
    @if (processLocked()) {
      <msf-input
        [model]="processDefinitionKey()"
        [label]="'Process'"
        [disabled]="true"
      ></msf-input>
    } @else {
      <msf-select
        [model]="processDefinitionKey()"
        (modelChange)="setProcessDefinitionKey($event)"
        [options]="processOptions()"
        optionLabel="label"
        optionValue="id"
        translateBy="locale"
        [placeholder]="'Process'"
      ></msf-select>
    }
    @if (visible()) {
      <app-quartz-schedule-fields
        (validChange)="scheduleValid.set($event)"
        [cronExpression]="cronExpression()"
        (cronExpressionChange)="setCronExpression($event)"
        [timeZoneId]="timeZoneId()"
        (timeZoneIdChange)="setTimeZoneId($event)"
      ></app-quartz-schedule-fields>
    }
    <app-checkbox
      label="Active"
      [ngModel]="isActive()"
      (ngModelChange)="setActive($event)"
    ></app-checkbox>
    @if (mode() === 'copy') {
      <small class="parameter-help">{{ 'Copy starts inactive' | translate }}</small>
    }
    @if (showSafePreview()) {
      <div class="safe-preview">
        <span>{{ 'Current safe parameter preview' | translate }}</span>
        <pre><code>{{ safePreviewJson() }}</code></pre>
      </div>
    }
    @if (processDefinitionKey()) {
      <app-assignment-start-form
        [processKey]="processDefinitionKey()"
        [seedJson]="parameterSeedJson()"
      ></app-assignment-start-form>
    }
  </div>
  <ng-template pTemplate="footer">
    <app-secondary-button
      title="Cancel"
      [disable]="saving()"
      (action)="close()"
    ></app-secondary-button>
    <app-primary-button
      title="Save"
      [loading]="saving()"
      [disable]="!canSave()"
      (action)="save()"
    ></app-primary-button>
  </ng-template>
</p-dialog>
